import { render, staticRenderFns } from "./ProductOutput.vue?vue&type=template&id=4d34bff8&scoped=true"
import script from "./ProductOutput.vue?vue&type=script&lang=js"
export * from "./ProductOutput.vue?vue&type=script&lang=js"
import style0 from "./ProductOutput.vue?vue&type=style&index=0&id=4d34bff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34bff8",
  null
  
)

export default component.exports